export default __webpack_public_path__ + "static/media/freeTag.df0a06da.svg";